import {Provider} from "react-redux";
import configure from "../../../store/configure";
import Layout from "../../../component/layout/Layout";
import InquiryDetailContainer from "../container/InquiryDetailContainer";
import React from "react";
import {useParams} from "react-router-dom";

const InquiryDetailPage = () => {
    const params = useParams();

    return (
        <Provider store={configure}>
            <Layout>
                <InquiryDetailContainer id={params.id} />
            </Layout>
        </Provider>
    );
};

export default InquiryDetailPage;